<div class="contact-us-wrapper" fxFlexFill fxLayout="row" fxLayoutAlign.gt-sm="center center" dir="rtl">
  <div class="contact-us-container"  fxLayout="column" style="padding: 0 .5em;" fxFlex.lt-md="100" fxFlex="63">
    <h1>{{ 'CONTACT.TITLE' | translate }}</h1>
    <div class="contact-us-form-container" fxFlexAlign="center">
      <form [formGroup]="contactForm" fxLayout="row wrap" fxLayoutGap=".5em grid" style="width: 100%;">
        <div class="input-container" fxFlex="1 1 40%" fxFlex.lt-md="1 1 100%">
          <span class="p-inputgroup-addon"><fa-icon [icon]="faUser"></fa-icon></span>
          <input type="text" fxFlex pInputText [placeholder]="'CONTACT.NAME_PLACEHOLDER' | translate">
        </div>
        <div class="input-container" fxFlex="1 1 40%" fxFlex.lt-md="1 1 100%">
          <span class="p-inputgroup-addon"><fa-icon [icon]="faEnvelope"></fa-icon></span>
          <input type="text" fxFlex  pInputText [placeholder]="'CONTACT.EMAIL_PLACEHOLDER' | translate">
        </div>
        <div class="input-container" fxFlex="1 1 40%" fxFlex.lt-md="1 1 100%">
          <span class="p-inputgroup-addon"><fa-icon [icon]="faPhone"></fa-icon></span>
          <input  type="text" fxFlex pInputText [placeholder]="'CONTACT.PHONE_PLACEHOLDER' | translate">
        </div>
        <div class="input-container" fxFlex="1 1 40%" fxFlex.lt-md="1 1 100%">
          <span class="p-inputgroup-addon"><fa-icon [icon]="faUser"></fa-icon></span>
          <input  type="text" fxFlex pInputText [placeholder]="'CONTACT.CONTACT_PERSON_PLACEHOLDER' | translate">
        </div>
        <div class="input-container" fxFlex="0 0 80%" fxFlex.lt-md="1 1 100%">
          <span class="p-inputgroup-addon"><fa-icon [icon]="faTitle"></fa-icon></span>
          <input  type="text" fxFlex pInputText [placeholder]="'CONTACT.SUBJECT_PLACEHOLDER' | translate">
        </div>
        <div class="textarea-container" fxFlex="0 0 80%" fxFlex.lt-md="1 1 100%">
          <textarea fxFlex [rows]="10"  pInputTextarea autoResize="autoResize" [placeholder]="'CONTACT.MESSAGE_PLACEHOLDER' | translate"></textarea>
        </div>
        <div class="submit-container" fxFlex="0 0 80%" fxLayoutAlign="flex-end" fxLayout="row" fxFlex.lt-md="1 1 100%">
          <button mat-raised-button  fxFlexAlign="flex-start">{{ 'CONTACT.SEND_BUTTON' | translate }}</button>
        </div>

      </form>
    </div>
  </div>
</div>
